<template>
    <div class="container">
        <seguro :carregando.sync="carregando" />
        <fonte-renda :carregando.sync="carregando" />
        <footer-simulador :loading.sync="carregando"/>
    </div>
</template>

<script>

import Seguro from './Seguros';
import FonteRenda from './FonteDeRenda';
import FooterSimulador from "@/components/common/FooterSimulador.vue";

export default {

    data() {
        return {
            carregando: false,
        }
    },

    name: 'segurosFonteDeRenda',

    components: {Seguro, FonteRenda, FooterSimulador}
}

</script>



// WEBPACK FOOTER //
// src/components/clientes/SegurosFonteDeRenda.vue